import { Routes } from '@angular/router';
import { AppCanLoad } from './app.service';
import { checkPasswordAge as checkPasswordAgeGuard } from './common/service';

export const ROUTES: Routes = [
  { path: 'error', loadChildren: './error/error.module#ErrorModule' },
  { path: 'logout', redirectTo: 'login' },
  {
    path: '', canActivateChild: [AppCanLoad], children: [
      { path: 'login', canLoad: [AppCanLoad], canActivateChild: [AppCanLoad], loadChildren: './login/login.module#LoginModule' },
      { path: 'forgot', canLoad: [AppCanLoad], canActivateChild: [AppCanLoad], loadChildren: './forgot/forgot.module#ForgotModule' },
      { path: 'resetpass', canLoad: [AppCanLoad], canActivateChild: [AppCanLoad], loadChildren: './resetpass/resetpass.module#ResetPasswordModule' },
      { path: 'signup', canLoad: [AppCanLoad], canActivateChild: [AppCanLoad], loadChildren: './signup/signup.module#SignupModule' },
      { path: 'confirmation', canLoad: [AppCanLoad], canActivateChild: [AppCanLoad], loadChildren: './confirmation/confirmation.module#ConfirmationModule' },
      { path: '', canLoad: [AppCanLoad], canActivateChild: [AppCanLoad, checkPasswordAgeGuard], loadChildren: './layout/layout.module#LayoutModule' },
    ]
  },
  { path: '**', canActivate: [checkPasswordAgeGuard], redirectTo: '/dashboard' }
];



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/app.routes.ts